import React from 'react';
import classes from './DifferenceMarker.css';

const differenceMarker = (props) => {

    let upArrowClasses = ["green-arrow"];
    let downArrowClasses = ["red-arrow"];

    if (props.value < 0) {
        upArrowClasses.push("hide-arrow");
    } else {
        downArrowClasses.push("hide-arrow");
    }

    return (
        <div className="DifferenceMarker">

            <div className="arrow-container">
                <div className={upArrowClasses.join(" ")}>
                    <i className="fas fa-arrow-circle-up"></i>
                </div>
                <div className={downArrowClasses.join(" ")}>
                    <i className="fas fa-arrow-circle-down"></i>
                </div>

            </div>

            <span>{props.value}%</span>

        </div>
    )
};

export default differenceMarker;


// WEBPACK FOOTER //
// ./src/components/DifferenceMarker/DifferenceMarker.js